import { Link } from "react-router-dom";

import MainLayout from "layouts/MainLayout";

const NotFound = () => {
    return (
        <MainLayout>
            <div className="p-4 mt-20 mx-auto text-center">
                Umm, 404 Not found. Check the URL maybe?

                <br /> <br />

                <Link to="/" className="text-lg text-blue-500">Click here to home page</Link>

                <br /> <br />

                <Link target="_blank" to="https://www.instagram.com/zennie.visuals" className="text-lg text-pink-500">Or click here to check instagram </Link> i guess if the site is under maintenance

            </div>
        </MainLayout>
    )
}

export default NotFound;